<template>
  <div class="store-selector">
    <label class="field-label" for="store-select">{{ $t('store') }}</label>
    <div class="select-wrap">
      <select
        id="store-select"
        :key="selectKey"
        :value="selectedValue"
        @change="onSelectChange"
        class="field-input"
      >
        <option value="" disabled>{{ $t('storePlaceholder') }}</option>
        <option
          v-for="s in stores"
          :key="s.id"
          :value="String(s.id)"
        >{{ s.name }}</option>
      </select>
      <span class="select-arrow">&#9662;</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StoreSelector',
  props: {
    value: { type: [Number, String], default: null }
  },
  data () {
    return {
      stores: []
    }
  },
  computed: {
    selectedValue () {
      if (this.value == null || this.value === '') return ''
      return String(this.value)
    },
    selectKey () {
      return this.stores.map(function (s) { return s.id }).join('-') + ':' + this.selectedValue
    }
  },
  watch: {
    value () {
      this.syncNativeSelect()
    },
    stores () {
      var self = this
      this.$nextTick(function () {
        self.syncNativeSelect()
      })
    }
  },
  created () {
    this.fetchStores()
  },
  methods: {
    onSelectChange (event) {
      var raw = event.target.value
      this.$emit('change', raw === '' ? null : Number(raw))
    },
    syncNativeSelect () {
      var el = this.$el && this.$el.querySelector('#store-select')
      if (!el) return
      el.value = this.selectedValue
    },
    filterVisibleStores (stores) {
      var hiddenStoreNames = ['test airport', 'demo airport']
      return (Array.isArray(stores) ? stores : []).filter(function (store) {
        return hiddenStoreNames.indexOf(String(store.name || '').trim().toLowerCase()) === -1
      })
    },
    async fetchStores () {
      try {
        const { data } = await axios.get('/api/luggage-storage/stores')
        this.stores = this.filterVisibleStores(data.data || data)
      } catch (e) {
        this.stores = [{ id: 1, name: 'Sydney Airport', timezone: 'Australia/Sydney' }]
      }
      this.$emit('loaded', this.stores)
    }
  }
}
</script>

<style scoped>
.store-selector { margin-bottom: 20px; }
.field-label { display: block; font-size: 13px; font-weight: 600; color: #1e336f; margin-bottom: 6px; }
.select-wrap { position: relative; }
.field-input {
  width: 100%; min-height: 48px; padding: 12px 40px 12px 14px; font-size: 16px;
  border: 1px solid #d4ddec; border-radius: 8px; background: #fff; color: #1e336f;
  appearance: none; -webkit-appearance: none; outline: none; transition: border-color .2s;
}
.field-input:focus { border-color: #1e336f; box-shadow: 0 0 0 3px rgba(30,51,111,.12); }
.select-arrow { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); pointer-events: none; color: #7b8fb8; font-size: 14px; }
@media (max-width: 480px) {
  .store-selector { margin-bottom: 16px; }
  .field-label { font-size: 14px; margin-bottom: 8px; }
  .field-input { min-height: 50px; border-radius: 10px; font-size: 16px; }
}
</style>



// WEBPACK FOOTER //
// src/components/StoreSelector.vue